export function toggleRelatedItems() {
  // Seleziona tutti gli elementi .toggle dentro .relatedItems
  const toggles = document.querySelectorAll(".relatedItems .toggle");

  toggles.forEach((toggle) => {
    // Aggiunge evento click e touch
    ["click", "touchstart"].forEach((eventType) => {
      toggle.addEventListener(eventType, () => {
        const parent = toggle.closest(".relatedItems");
        if (parent) parent.classList.toggle("open");
      });
    });
  });
}
